<template>
    <div>
        <f7-list v-if="myShortEvents.length === 0 && isLoaded">
            <f7-list-item :title="'You don\'t have any activity notifications yet.'" />

        </f7-list>
        <template v-else>
            <f7-list media-list>
                <sequential-entrance from-bottom>
                    <template v-for="(event, index) in myShortEvents">
                        <event-card
                            :event="event"
                            :key="`event-${index}`"
                            :home="true"
                        />
                    </template>
                </sequential-entrance>
            </f7-list>
            <p
                v-if="hasMoreEvents"
                class="moreLinks"
            >
                <a
                    href="/activity"
                    class="moreLink"
                >View all &mdash;</a>
            </p>
        </template>
    </div>
</template>

<script>
import EventCard from '../../components/eventCard.vue';

export default {
    store: ['api', 'myBookmarks', 'unreadEvents', 'myEvents'],
    components: {
        EventCard
    },
    data () {
        return {
            isLoaded: false,
            hasMoreEvents: false,
            myShortEvents: []
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        },
        maxItems: function () {
            return window.innerHeight > 1000 ? 4 : 2;
        }
    },
    created: function () {
        this.getEvents();
    },
    mounted: function () { },
    methods: {
        getEvents: function () {
            this.$http.get(`${this.api}/events?read=1`).then(
                response => {
                    let myEvents = response.body;
                    for (let i = 0; i < myEvents.length; i++) {
                        const event = myEvents[i];
                        event.title = this.renderEventTitle(event);
                        event.subtitle = this.renderEventTitle(event, true);
                        event.link = this.renderEventLink(event);
                    }
                    this.hasMoreEvents = !!(myEvents.length > this.maxItems);
                    this.myEvents = myEvents;
                    this.myShortEvents = myEvents.splice(0, this.maxItems);
                    this.unreadEvents = 0;
                    this.isLoaded = true;
                },
                () => {
                    console.error('Could not fetch events');
                }
            );
        },
        renderEventTitle: function (event, isSubtitle) {
            let text = '';
            let subtitle = '';
            if (event.name === 'day_complete') {
                text = `Completed day ${event.itemId + 1}`;
            }
            if (event.name === 'comment_like' && event.comment) {
                text = `@${event.fromUser.username} ${event.comment.parentId ? 'liked' : 'upvoted'} your comment`;
                subtitle = event.comment.text;
            }
            if (event.name === 'comment_reply') {
                text = `@${event.fromUser.username} replied to your comment`;
                subtitle = event.comment.text;
            }
            if (event.name === 'comment_mention') {
                text = `@${event.fromUser.username} mentioned you in a comment`;
                subtitle = event.comment.text;
            }
            if (isSubtitle) return subtitle;
            return text;
        },
        renderEventLink: function (event) {
            if (event.name === 'comment_like') {
                if (event.comment.parentId) return `/replies/${event.comment.parentId}`;
                else return `/units/${event.comment.unitId}/comments`;
            }
            if (event.name === 'comment_reply') {
                return `/units/${event.comment.unitId}/comments`;
            }
            if (event.name === 'comment_mention') {
                return `/comments/${event.comment.unitId}`;
            }
            return false;
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.moreLinks {
    padding: 0;
    text-align: right;
    margin: -20px 16px 0;
    text-transform: uppercase;
    font-family: AndesMedium;
    letter-spacing: 1px;
    font-weight: bold;
    font-size: 12px;
    color: #ff6f61;
    letter-spacing: 0.8px;
}
.moreLink {
    font-size: 15px;
    color: @coral;
    font-family: AndesMedium;
    text-transform: uppercase;
    line-height: 44px;
    float: right;
    z-index: 100;
    position: relative;
}
</style>
